export default {
  path: '/draw',
  meta: {
    title: '抽奖',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/draw`),
}



// WEBPACK FOOTER //
// ./src/views/Draw/router.js